"use strict";
import {
    searchUrlParam,
} from './commons/utm.js';

import {
    domElementExistByQuery
} from './commons/domCheck.js';

import {
    endYoutubeVideo
} from './commons/youtube.js';


document.addEventListener("DOMContentLoaded", () => {


    if (domElementExistByQuery("#script-dts") || domElementExistByQuery("#script-dts-logueado")) {
        // Flickity Carousel

        var elem = document.querySelector('.main-carousel');
        var flkty = new Flickity(elem, {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            fade: true,
            wrapAround: true
        });
    }

    if (domElementExistByQuery("#script-dts-logueado")) {
        const loaderPage = document.getElementById("loader-page");
        const url = document.getElementById("adminUrl").innerHTML;
        const userEmail = document.querySelector("#user-menu span").innerHTML;
        const dtsId = document.getElementById("dtsId").value;
        var form;

        checkUserLogedInCurrentDTS();



        function checkUserLogedInCurrentDTS() {
            loaderPage.classList.add("visible");
            isLogedInCurrentDTS().then(isLoged => {
                const isTrueSet = (isLoged === "true");
                changeDomIfUserLogedInDts(isTrueSet);
                loaderPage.classList.remove("visible");
            });
        }

        function changeDomIfUserLogedInDts(userLoged) {

            if (userLoged) {
                document.querySelector('.pageTrainningSession__intro__text--registered').classList.remove('ac-dp--none');
                document.querySelector('.pageTrainningSession__intro__text--form').classList.add('ac-dp--none');
            } else {
                document.querySelector('.pageTrainningSession__intro__text--form').classList.remove('ac-dp--none');
                activeFormListener();
            }

        }

        function activeFormListener() {
            form = document.getElementById("formDts");
            form.addEventListener("submit", sendData)
        }

        async function isLogedInCurrentDTS() {
            const formDataLoged = new FormData();
            formDataLoged.append('action', 'isRegisteredInCurrentTrainingSession');
            formDataLoged.append('email', userEmail);
            formDataLoged.append('dts_id', dtsId);
            let loged;
            await fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: formDataLoged,
            })
                .then(resp => resp.text())
                .then(resp => {
                    loged = resp;
                });
            return loged
        }

        function sendData(e) {

            e.preventDefault();

            const formData = new FormData(form);
            const formBtn = form.querySelector("button");

            formData.append('action', 'registerTrainingSession');
            formData.append('email', userEmail);
            formData.append('dts_id', dtsId);
            formData.append('from_form', 'training-session');
            formData.append('utm_source', searchUrlParam('utm_source'));
            formData.append('utm_campaign', searchUrlParam('utm_campaign'));
            formData.append('utm_content', searchUrlParam('utm_content'));
            formData.append('utm_term', searchUrlParam('utm_term'));
            formData.append('utm_medium', searchUrlParam('utm_medium'));
            formData.append('origin', searchUrlParam('origin'));

            formBtn.disabled = true;
            loaderPage.classList.add("visible");

            fetch(url, {
                method: "POST",
                credentials: "same-origin",
                body: formData,
            })
                .then(resp => resp.text())
                .then(resp => {
                    if (resp != 'SecurityHelper: error submision') {
                        changeDomIfUserLogedInDts(true);
                        loaderPage.classList.remove("visible");
                    } else {
                        console.warn(resp);
                        formBtn.disabled = false;
                        loaderPage.classList.remove("visible");
                    }
                })
                .catch((error) => {
                    console.log('Algo salio mal: ', error)
                    formBtn.disabled = false;
                    loaderPage.classList.remove("visible");
                });


        }


        document.addEventListener('click', function (e) {
            e = e || window.event;
            var target = e.target || e.srcElement;

            if (target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') == 'pageTrainningSession__previousDTS__modal') {
                if (target.hasAttribute('data-target')) {
                    var m_ID = target.getAttribute('data-target');
                    document.getElementById(m_ID).classList.add('pageTrainningSession__previousDTS__modal--open');
                    document.body.style.overflow = 'hidden';
                    e.preventDefault();
                }
            }

            // Close modal window with 'data-dismiss' attribute or when the backdrop is clicked
            if ((target.hasAttribute('data-dismiss') && target.getAttribute('data-dismiss') == 'pageTrainningSession__previousDTS__modal') || target.classList.contains('pageTrainningSession__previousDTS__modal')) {
                var modal = document.querySelector('[class="pageTrainningSession__previousDTS__modal pageTrainningSession__previousDTS__modal--open"]');
                modal.classList.remove('pageTrainningSession__previousDTS__modal--open');
                document.body.style.overflow = 'auto';

                endYoutubeVideo(document.querySelectorAll('.playerIframe'));
                e.preventDefault();
            }
        }, false);
    }


});




